export default __webpack_public_path__ + "static/media/clock.5eb51dbe.png";